itsoftApp.createModule("scrollActions", function () {
    var module = this;
    var queue = [];
    var loadingStarted = false;
    var moduleInitialized = false;
    var registeredPlugin = false;
    var header = document.querySelector("#header");
    var feature = document.querySelector("#feature");
    var infoItems = document.querySelector(".info__items");
    var viewheight = window.innerHeight;
    var viewport = document.documentElement.clientWidth;
    var headerHeight = itsoftApp.commonVars.headerHeight;

    itsoftApp.modules.windowResize.addEvent(function () {
        viewheight = window.innerHeight;
        viewport = document.documentElement.clientWidth;
        headerHeight = itsoftApp.commonVars.headerHeight;
    });

    var initScrollActions = function (element) {

        if (!registeredPlugin) {
            registeredPlugin = true;
            // регистрируем дополнительный плагин, чтобы анимации работали при скролле
            gsap.registerPlugin(ScrollTrigger);
        }

        if (typeof element === "function") {
            element();
        } else {
            if (element.classList.contains("js-feature")) {
                element.classList.remove("js-feature");

                var infoBlocks = document.querySelectorAll("[data-info]");
                var activeSection;

            // прикрепляем блок с преимуществами с крутящимся небулайзером
                ScrollTrigger.create({
                  trigger: ".page__feature-section",
                  pin: "#feature",
                  anticipatePin: 1,
                  start: "top top",
                  end: "bottom bottom",
                  onEnter: function (self) {
                      ScrollTrigger.refresh();
                  }
                  // refreshPriority: 1,
                  // onEnter: function (self) {
                  //      ScrollTrigger.refresh();
                  // }
                  // markers: true
                });

            // показываем/скрываем нужные секции в блоке с преимуществами на десктопе
                // ScrollTrigger.saveStyles(".feature__canvas");
                // ScrollTrigger.saveStyles(".feature__info");
                ScrollTrigger.create({
                  trigger: ".page__feature-section",
                  start: "top top+=" + headerHeight, 
                  end: "bottom top",
                  // markers: true,
                  // refreshPriority: 2,
                  // onEnter: function (self) {
                  //      ScrollTrigger.refresh();
                  // },
                  onLeaveBack: function (self) {
                    if (activeSection && activeSection.classList.contains("js-show")) {
                        activeSection.classList.remove("js-show");
                    }
                  },
                  onLeave: function (self) {
                    if (activeSection && activeSection.classList.contains("js-show")) {
                        activeSection.classList.remove("js-show");
                    }
                  },
                  onUpdate: function (self) {
                    if (self.progress.toFixed(3) >= 0 && self.progress.toFixed(3) < 0.25) {
                        if (activeSection) {
                            activeSection.classList.remove("js-show");
                        }
                        activeSection = infoBlocks[0];
                        feature.classList.remove("feature--section-2");
                        feature.classList.add("feature--section-1");
                        activeSection.classList.add("js-show");

                    } else if (self.progress.toFixed(3) >= 0.25 && self.progress.toFixed(3) < 0.5) {
                        if (activeSection) {
                            activeSection.classList.remove("js-show");
                        }
                        activeSection = infoBlocks[1];
                        feature.classList.remove("feature--section-1");
                        feature.classList.add("feature--section-2");
                        feature.classList.remove("feature--section-3");
                        activeSection.classList.add("js-show");
                    } else if (self.progress.toFixed(3) >= 0.5 && self.progress.toFixed(3) < 0.75) {
                        if (activeSection) {
                            activeSection.classList.remove("js-show");
                        }
                        activeSection = infoBlocks[2];
                        feature.classList.remove("feature--section-2");
                        // feature.classList.remove("feature--section-4");
                        feature.classList.add("feature--section-3");
                        activeSection.classList.add("js-show");
                    }
                  }

                /* На мобильном и планшетном разрешении чуть другая логика,
                // так как секции не на всю высоту экрана из-за особенностей устройств */
                //     "(max-width: 1279px)": function() {
                //         gsap.utils.toArray(".feature__info").forEach(function (featureItem, i) {
                //             ScrollTrigger.create({
                //                 trigger: featureItem,
                //                 start: "top 80%", 
                //                 end: "top 20%",
                //                 toggleClass: "js-show"
                //             });
                //         });
                //     },
                    // "(max-width: 1279px)": function() {
                    //     gsap.utils.toArray(".feature__info").forEach(function (featureItem, i) {
                    //         ScrollTrigger.create({
                    //             trigger: featureItem,
                    //             pin: true,
                    //             start: "top top", 
                    //             end: "+600",
                    //             refreshPriority: 2,
                    //             toggleClass: {
                    //                 targets: ".feature__canvas",
                    //                 className: "js-show"
                    //             }
                    //         });
                    //     });
                    // },
                });
            }

        /* Привязываем анимацию использования небулайзера непосредственно к значению
        текущего скролла */ 

            /* Метод saveStyles важен, иначе десктопная и мобильная версии будут конфликтовать
            из-за инлайновых стилей, которые вставляет ScrollTrigger */
            // var angle = degToRadians(360);
            // ScrollTrigger.matchMedia({
            //     "(min-width: 1280px)": function() {
            //         var modelTimeline = gsap.timeline({
            //             scrollTrigger: {
            //                 trigger: "#feature",
            //                 start: "top " + headerHeight,
            //                 end: infoBlocks[0].offsetHeight * 4
            //             }
            //         })
            //         // if (window.mesh) {
            //             modelTimeline.to(window.mesh.rotation, {
            //                 y: angle
            //             })
            //         // }
            //     }
            // });
            
            if (element.classList.contains("js-info")) {
                element.classList.remove("js-info");
                ScrollTrigger.saveStyles(".info__image-wrapper");
                ScrollTrigger.saveStyles(".info__text");

                ScrollTrigger.create({
                    trigger: "#info",
                    start: "top top+=" + headerHeight,
                    end: "bottom top+=" + headerHeight,
                    toggleClass: {
                        targets: ".page-header",
                        className: "page-header--hide"
                    },
                });

                ScrollTrigger.matchMedia({
                    "(min-width: 1024px)": function () {
                        var infoAnimation = gsap.timeline({
                            scrollTrigger: {
                                trigger: "#info",
                                start: "top top",
                                end: "bottom bottom",
                                anticipatePin: 1,
                                pin: ".info__items",
                                onEnter: function (self) {
                                    ScrollTrigger.refresh();
                                }
                                // markers: true
                            }
                        }); 
                    }

                    // "(max-width: 1023px)": function () {
                    //     var infoAnimation = gsap.timeline({
                    //         scrollTrigger: {
                    //             trigger: "#info",
                    //             start: "top top",
                    //             end: "bottom bottom",
                    //             anticipatePin: 1,
                    //             pin: ".info__items",
                    //             onEnter: function (self) {
                    //                   ScrollTrigger.refresh();
                    //             }
                    //             // markers: true
                    //         }
                    //     });
                    // }
                });

                ScrollTrigger.matchMedia({
                    "(max-width: 1023px)": function () {
                        var infoAnimation = gsap.timeline({
                            scrollTrigger: {
                                trigger: "#info",
                                start: "top top",
                                end: "590px",
                                toggleActions: "play none reverse none",
                                onUpdate: function (self) {
                                    if (self.progress.toFixed(3) >= 0.5) {
                                        infoItems.classList.add("js-toggle");
                                    } else {
                                        infoItems.classList.remove("js-toggle");
                                    }
                                }
                                // scrub: true
                                // markers: true
                            }
                        })
                        .add("start")
                        // .from(".info__image-wrapper--treatment", {
                        //     x: "-100vw"
                        // })
                        // .from(".info__text--treatment", {
                        //     x: "100vw"
                        // })
                        // .from(".info__image-wrapper--technology", {
                        //     x: 0
                        // })
                        // .from(".info__text--technology", {
                        //     x: 0
                        // })
                        // .add("pause")
                        // .to(".info__image-wrapper--technology", {
                        //     x: "-100vw"
                        // }, "pause")
                        // .to(".info__text--technology", {
                        //     x: "100vw"
                        // }, "pause")
                        // .add("nextStep")
                        // .to(".info__text--treatment", {
                        //     x: 0,
                        // }, "nextStep")
                        // .to(".info__image-wrapper--treatment", {
                        //     x: 0,
                        // }, "nextStep")
                    },

                    "(min-width: 1024px)": function () {
                        var infoAnimation = gsap.timeline({
                            scrollTrigger: {
                                trigger: "#info",
                                start: "top top",
                                end: "bottom bottom",
                                scrub: 0.5
                                // markers: true
                            }
                        })
                        .fromTo(".info__image-wrapper--technology", {
                            width: "100%",
                            paddingTop: viewheight / viewport * 100 + "%"
                        }, {
                            width: "53.819%",
                            paddingTop: "21.8056%"
                        })
                        .to(".info__text--technology", {
                            x: 0
                        }, "-=0.5")
                        .add("firstShowEnd")
                        .to(".info__image-wrapper--technology", {
                            x: "-100%",
                            opacity: 0
                        }, "firstShowEnd")
                        .add("firstHideImageEnd")
                        .to(".info__text--technology", {
                            x: "100vw"
                        }, "firstHideImageEnd+=0.05")
                        .to(".info__image-wrapper--treatment", {
                            x: 0
                        }, "firstHideImageEnd")
                        .fromTo(".info__image-wrapper--treatment", {
                            width: "100%",
                            paddingTop: viewheight / viewport * 100 + "%"
                        }, {
                            width: "53.819%",
                            paddingTop: "21.8056%"
                        })
                        .to(".info__text--treatment", {
                            x: 0
                        }, "-=0.5")
                    }
                });
            } 
            
            if (element.classList.contains("js-technology")) {
                element.classList.remove("js-technology");
                ScrollTrigger.saveStyles(".technology__device-wrapper");

                ScrollTrigger.matchMedia({
                    "(min-width: 1280px)": function() {
                        var tlScroll = gsap.timeline({
                            scrollTrigger: {
                                trigger: "#technology",
                                start: "top top",
                                end: "bottom 68%",
                                scrub: 0.5,
                                // markers: true
                            }
                        })
                        tlScroll.from(".technology__device-wrapper", {
                            xPercent: -28
                        })
                        .to(".technology__device-wrapper", {
                            xPercent: 0
                        });
                    },

                    "(max-width: 1279px)": function() {
                        var tlScroll2 = gsap.timeline({
                            scrollTrigger: {
                                trigger: "#technology",
                                start: "top 40%",
                                end: "+=200",
                                scrub: 0.5
                            }
                        })
                        tlScroll2.from(".technology__device-wrapper", {
                            xPercent: -13 //-28
                        })
                        .to(".technology__device-wrapper", {
                            xPercent: 0 //-28
                        });
                    }
                })
            }

            if (element.classList.contains("js-advantages")) {
                element.classList.remove("js-advantages");

                var infoBlocks = document.querySelectorAll("[data-info]");
            /* Переключаем класс шапки сайта, чтобы менялся его внешний вид на тёмном/ярком фоне */
                    ScrollTrigger.create({
                        trigger: ".page__feature-section",
                        start: "top top+=" + headerHeight,
                        end: "bottom top-=" + headerHeight,
                        toggleClass: {
                            targets: ".page-header",
                            className: "page-header--hide"
                        },
                    });

                    // "(max-width: 1279px)": function() {
                    //     ScrollTrigger.create({
                    //         trigger: "#feature",
                    //         start: "top " + headerHeight,
                    //         end: "bottom top+=" + headerHeight,
                    //         toggleClass: {
                    //             targets: ".page-header",
                    //             className: "page-header--dark"
                    //         },
                    //         refreshPriority: 1,
                    //         onEnter: function (self) {
                    //             ScrollTrigger.refresh();
                    //         }
                    //     });
                    // }

                // ScrollTrigger.saveStyles(".page-header");
            /* Показываем кнопку "Где купить" в шапке (на десктопе), после того,
            как проскроллили первый экран */
                ScrollTrigger.matchMedia({
                    "(min-width: 1024px)": function() {
                        ScrollTrigger.create({
                            trigger: "#intro-button",
                            start: "bottom " + headerHeight,
                            endTrigger: ".l-wrapper",
                            end: "bottom top",
                            toggleClass: {
                                targets: ".page-header",
                                className: "js-fixed"
                            }
                        });
                    }
                })

                ScrollTrigger.create({
                    trigger: ".l-wrapper",
                    start: "top -5",
                    toggleClass: {
                        targets: ".page-header",
                        className: "page-header--bg"
                    }
                });
            }
        }
    }

    var initScrollLibrary = function (element) {

        if (!moduleInitialized) {
            queue.push(element);

            if (!loadingStarted) {
                loadingStarted = true;
                itsoftApp.loadScript("/assets/scripts/gsap/gsap.min.js", function () {
                    itsoftApp.loadScript("/assets/scripts/gsap/ScrollTrigger.min.js", function () {
                        moduleInitialized = true;
                        while (queue.length > 0) {
                            initScrollActions(queue.shift());
                        }
                    });
                });
            }
        } else {
            initScrollActions(element);
        }
    }

    module.callback = initScrollLibrary;
});